import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import HomeNutritionSections from './components/HomeNutritionSections'; /* 
import ServicesScroll from './components/ServicesCards';
import ProcessSection from './components/ProcessSection'; */
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
/* import ProductSection from './components/ProductSection'; */
import Testimonials from './components/Testimonials';
/* import CTASection from './components/CTASection';*/
import NutritionPage from './components/NutritionPage';
import ProductListingPage from './components/ProductListingPage';
import ProductDetails from './components/ProductDetails';
import CategoryProductsPage from './components/CategoryProductsPage';
import FullAbout from './components/FullAbout';
import ContactPage from './components/ContactPage';
import DistributorsPage from './components/DistributorsPage';
import FloatingButtons from './components/FloatingButtons';
import Footer from './components/Footer';
import Lenis from '@studio-freight/lenis';
import './App.css';
import { useLocation } from 'react-router-dom';

import { motion, AnimatePresence } from 'framer-motion';
import VideoLoader from './components/VideoLoader';

const Home = () => {
  return (
    <>
      <Hero />
      <AboutSection />
      <HomeNutritionSections />
     {/*  <ServicesScroll />
      <ProcessSection /> 
      <ProductSection />
       <CTASection />*/}
      <Testimonials />
    </>
  );
};

function App() {
  const [lenis, setLenis] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    // Initialize Lenis
    const instance = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      direction: 'vertical',
      gestureDirection: 'vertical',
    });

    setLenis(instance);

    function raf(time) {
      instance.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      instance.destroy();
      clearTimeout(timer);
    };
  }, []);

  const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
      if (lenis) {
        lenis.scrollTo(0, { immediate: true });
      }
    }, [pathname]);
    return null;
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <AnimatePresence mode="wait">
          {isLoading && (
            <motion.div
              key="loader"
              initial={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            >
              <VideoLoader />
            </motion.div>
          )}
        </AnimatePresence>

        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<FullAbout />} />
            <Route path="/distributors" element={<DistributorsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/nutrition" element={<NutritionPage />} />
            <Route path="/products" element={<ProductListingPage />} />
            <Route path="/dog-products" element={<ProductListingPage />} />
            <Route path="/cat-products" element={<ProductListingPage />} />
            <Route path="/other-products" element={<ProductListingPage />} />
            <Route path="/category/:pet/:category" element={<CategoryProductsPage />} />
            <Route path="/dog-products/:id" element={<ProductDetails />} />
            <Route path="/cat-products/:id" element={<ProductDetails />} />
            <Route path="/other-products/:id" element={<ProductDetails />} />
          </Routes>
        </main>
        <FloatingButtons />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
